import { render, staticRenderFns } from "./PasswordChangeForm.vue?vue&type=template&id=766849f0&scoped=true"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=ts"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766849f0",
  null
  
)

export default component.exports